const SET_IS_LOADING = "ADVISORS/SET_IS_LOADING";
const SET_ERROR = "ADVISORS/SET_ERROR";
const SET_PAGE = "ADVISORS/SET_PAGE";
const RESET = "ADVISORS/RESET";

const Types = {
  SET_IS_LOADING,
  SET_ERROR,
  SET_PAGE,
  RESET,
};

export default Types;
